(function() {
    document.addEventListener("DOMContentLoaded", function() {
      const params = new URLSearchParams(window.location.search);
      if (params.get("clear_cart") === "true") {
        fetch("/cart/clear.js", { method: "POST" })
          .then(() => {
            console.log("Cart cleared by URL parameter");

            // Remove the param from URL so it doesn't loop
            params.delete("clear_cart");
            const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
            window.history.replaceState({}, document.title, newUrl);

            // Fetch updated cart drawer section HTML
            return fetch("/?section_id=sections--18174717001920__cart-drawer");
          })
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartItems = doc.querySelector("cart-items");
            const oldCartItems = document.querySelector("cart-items");

            if (newCartItems && oldCartItems) {
              oldCartItems.replaceWith(newCartItems);
              console.log("Cart drawer refreshed");
            }

            // Also reset cart counters
            fetch("/cart.js")
              .then(res => res.json())
              .then(cart => {
                document.querySelectorAll("[data-cart-count], .cart-count, cart-count")
                  .forEach(el => {
                    el.textContent = cart.item_count;
                    el.setAttribute("aria-label", cart.item_count + " ელემენტი");
                  });
              });
          })
          .catch(err => console.error("Cart clear failed:", err));
      }
    });
  })();